import { render, staticRenderFns } from "./routDetail.vue?vue&type=template&id=7673d018&scoped=true"
import script from "./routDetail.vue?vue&type=script&lang=js"
export * from "./routDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7673d018",
  null
  
)

export default component.exports